"use client";
import { useCallback } from "react";
import Translations from "@translate/components/Member/Subscription/SubscriptionCardH5/CardList/SubscribableTerms";
import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";
import { agreement } from "@/src/const/agreement";
import { MessageType } from "@/src/lib/bridge/types";
import { useBridge } from "@/src/lib/bridge/useBridge";

const I18n = I18nUtil.createScoped(Translations);

/** 订阅条款 */
export const SubscribableTerms = () => {
  const { send, isInApp } = useBridge();

  const openExternalUrl = useCallback(
    (url: string) => {
      if (isInApp) {
        send(MessageType.OPEN_URL_EXTERNAL, { url });
        return;
      }
      window.open(url, "_blank");
    },
    [isInApp, send],
  );

  const handleTermsClick = () => {
    openExternalUrl(agreement.termsLink);
  };

  const handlePrivacyClick = () => {
    openExternalUrl(agreement.privacyLink);
  };

  return (
    <div className={cn("text-content_tertiary body_s mt-3 text-center")}>
      {I18n.t(
        "Cancel anytime. No refunds for partial billing periods, except as required by applicable law. By subscribing, you agree to our",
      )}{" "}
      <span
        data-openreplay-label={`CardList · CardListH5 · span | ${I18n.t("Terms of Use")}`}
        className="underline decoration-solid underline-offset-3 cursor-pointer bg-transparent border-0 p-0 hover:text-content_primary transition-colors"
        onClick={handleTermsClick}
      >
        {I18n.t("Terms of Use")}
      </span>{" "}
      {I18n.t("and")}{" "}
      <span
        data-openreplay-label={`CardList · CardListH5 · span | ${I18n.t("Privacy Policy")}`}
        className="underline decoration-solid underline-offset-3 cursor-pointer bg-transparent border-0 p-0 hover:text-content_primary transition-colors"
        onClick={handlePrivacyClick}
      >
        {I18n.t("Privacy Policy")}
      </span>
    </div>
  );
};
